export default "__VITE_ASSET__FITZiEe1__"